import * as classnames from "classnames";
import { isEqual } from "lodash";
import * as React from "react";

import { Modal, Icon, Msg } from "../../../../shared/components";

/**
 * Prop interface
 */
export interface ResetChallengeProps {
  isOpen: boolean;
  onReset?: () => void;
  onCancel?: () => void;
}

/**
 * Page component
 */
class ResetChallenge extends React.Component<ResetChallengeProps> {
  constructor(props: ResetChallengeProps) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: ResetChallengeProps) {
    return !isEqual(nextProps, this.props);
  }

  public render() {
    const { isOpen, onCancel, onReset } = this.props;

    const rootStyle = classnames("code-reset-challenge");

    return (
      <Modal
        className={rootStyle}
        title={<Msg id={"reset-challenge.title"} />}
        isOpen={isOpen}
        onClose={onCancel}
        onClickCancel={onCancel}
        onClickOk={onReset}
        okButtonLabel={<Msg id={"button.resetChallenge"} />}
        okButtonAriaLabel="Reset"
        ariaLabel="Reset Challenge"
      >
        <div className="code-reset-challenge__body">
          <div className="code-reset-challenge__item">
            <Icon
              type="exclamation-triangle"
              iconClassName="fa-3x"
              size="large"
            />
          </div>
          <div className="code-reset-challenge__item">
            <p>
              <Msg id={"reset-challenge.text1"} />
            </p>
            <p>
              <Msg id={"reset-challenge.text2"} />
            </p>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ResetChallenge;
